<template>
  <section class="image-text-block" :class="positionClass">
    <div class="image-text-block__container">
      <div class="image-text-block__image-wrapper" v-if="data.image">
        <div class="image-text-block__image">
          <img
              :src="data.image"
              :alt="data.title || 'Изображение'"
          />
        </div>
      </div>

      <div class="image-text-block__content-wrapper">
        <div class="image-text-block__content">
          <h2
              class="image-text-block__title"
              v-if="data.title"
              :class="titleClass"
          >
            {{ data.title }}
          </h2>

          <div
              class="image-text-block__subtitle"
              v-if="data.subtitle"
          >
            <p class="text-circe-bold-22">{{ data.subtitle }}</p>
          </div>
          <div v-else>
            <br>
          </div>

          <div
              class="image-text-block__section-title"
              v-if="data.section_title"
          >
            <p class="text-circe-bold-22 color-green">{{ data.section_title }}</p>
          </div>
          <div v-else>
            <br>
          </div>

          <div class="image-text-block__text" v-if="data.content">
            <p :class="textClass">{{ data.content }}</p>
          </div>

          <div
              class="image-text-block__button"
              :class="buttonPositionClass"
              data-aos="fade-up"
              data-aos-duration="1000"
              v-if="showButton">
            <button
                class="image-text-block__btn"
                @click="handleButtonClick"
            >
              {{ data.button.text }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import 'aos/dist/aos.css';
import AOS from 'aos'

export default {
  name: 'UniversalImageTextBlock',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  mounted() {
    AOS.init();
  },
  computed: {
    showButton() {
      return this.data.showButton !== false
        && this.data.button
        && !!this.data.button.text;
    },
    isImageRight() {
      return this.data.imagePosition === 'right';
    },
    positionClass() {
      return {
        'image-text-block--image-right': this.isImageRight,
        'image-text-block--image-left': !this.isImageRight
      };
    },
    titleClass() {
      return {
        'text-TTDrugs-Bold-40': true,
        'color-green': this.data.titleColor === 'green' || !this.data.titleColor
      };
    },
    textClass() {
      return {
        'text-circe-20': true
      };
    },
    buttonPositionClass()
    {
      return {
        'image-text-block__button--left': this.isImageRight,
        'image-text-block__button--right': !this.isImageRight
      };
    },
  },
  methods: {
    handleButtonClick() {
      if (this.data.button.link) {
        if (this.data.button.link.startsWith('http')) {
          window.open(this.data.button.link, '_blank');
        } else {
          this.$router.push(this.data.button.link);
        }
      }
      if (this.data.button.action) {
        this.$emit('button-click', this.data.button.action);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.image-text-block {
  max-width: 1600px;
  margin: 50px 0;
  width: 100%;
  box-sizing: border-box;

  &__container {
    display: flex;
    min-height: 0;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background: white;
    height: 500px;
    width: 100%;
    box-sizing: border-box;
    padding: 0;
  }

  &__image-wrapper {
    flex: 0 0 50%;
    width: 50%;
    min-height: 0;
    display: flex;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  &__image {
    width: 100%;
    height: 100%;
    display: flex;
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      display: block;
      transition: transform 0.3s ease;
      flex-shrink: 0;
      margin: 0;
      padding: 0;

      &:hover {
        transform: scale(1.02);
      }
    }
  }

  &__content-wrapper {
    flex: 0 0 50%;
    width: 50%;
    min-height: 0;
    display: flex;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  &__content {
    flex: 1;
    padding: 40px 50px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    margin: 0;
    box-sizing: border-box;
  }

  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.3;
    overflow-wrap: break-word;
    word-break: break-word;
    flex-shrink: 0;
  }

  &__subtitle {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 12px;
    overflow-wrap: break-word;
    flex-shrink: 0;
  }

  &__section-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 12px;
    overflow-wrap: break-word;
    flex-shrink: 0;
  }

  &__text {
    margin-top: 20px;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 0;
    overflow-wrap: break-word;
    word-break: break-word;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #66cc66;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #469e46;
    }
  }

  &__btn {
    font-family: 'TTDrugs', sans-serif;
    font-size: 20px;
    min-width: 250px;
    max-width: 100%;
    font-weight: 300;
    background-color: #6c6;
    color: #ffffff;
    border: none;
    padding: 11px 25px;
    border-radius: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    flex-shrink: 0;

    &:hover {
      background-color: #469e46;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(46, 125, 50, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  &__button {
    margin-top: 25px;
    flex-shrink: 0;
  }

  &__button--left {
    display: flex;
    justify-content: flex-start;
  }

  &__button--right {
    display: flex;
    justify-content: flex-end;
  }
}

/* Изображение слева - скругление справа для контента */
.image-text-block--image-left {
  .image-text-block__container {
    flex-direction: row;
  }

  .image-text-block__image-wrapper {
    border-radius: 20px 0 0 20px;
  }

  .image-text-block__image img {
    border-radius: 20px 0 0 20px;
  }

  .image-text-block__content-wrapper {
    border-radius: 0 20px 20px 0;
  }
}

/* Изображение справа - скругление слева для контента */
.image-text-block--image-right {
  .image-text-block__container {
    flex-direction: row-reverse;
  }

  .image-text-block__image-wrapper {
    border-radius: 0 20px 20px 0;
  }

  .image-text-block__image img {
    border-radius: 0 20px 20px 0;
  }

  .image-text-block__content-wrapper {
    border-radius: 20px 0 0 20px;
  }
}

@media (max-width: 1200px) {
  .image-text-block {
    margin: 20px 0;

    &__container {
      height: 450px;
    }

    &__content {
      padding: 30px 40px;
    }

    &__title {
      font-size: 32px;
    }

    &__subtitle,
    &__section-title {
      font-size: 20px;
    }

    &__text {
      font-size: 18px;
    }
  }
}

@media (max-width: 1024px) {
  .image-text-block {
    margin: 20px 0;
    width: 100%;
    padding: 0;

    &__container {
      flex-direction: column !important;
      height: auto;
      border-radius: 20px;
    }

    &__image-wrapper {
      flex: 0 0 auto;
      width: 100%;
      height: 350px;
      border-radius: 20px 20px 0 0 !important;
    }

    &__image img {
      border-radius: 20px 20px 0 0 !important;
    }

    &__content-wrapper {
      flex: 0 0 auto;
      width: 100%;
      border-radius: 0 0 20px 20px !important;
    }

    &__content {
      padding: 20px;
      height: auto;
    }

    &__title {
      font-size: 36px;
      text-align: center;
    }

    &__subtitle,
    &__section-title {
      font-size: 24px;
      text-align: center;
    }

    &__text {
      font-size: 18px;
      max-height: none;
      overflow-y: visible;
      margin-bottom: 20px;
      flex: none;
    }

    &__button {
      margin-top: 20px;
    }

    &__button--left,
    &__button--right {
      justify-content: center;
    }
  }
}

@media (max-width: 768px) {
  .image-text-block {
    margin: 15px 0;
    width: 100%;

    &__image-wrapper {
      height: 250px;
    }

    &__content {
      padding: 25px 20px;
    }

    &__title {
      font-size: 28px;
      margin-bottom: 15px;
    }

    &__subtitle,
    &__section-title {
      font-size: 20px;
      margin-bottom: 10px;
    }

    &__text {
      font-size: 16px;
      margin-bottom: 15px;
    }

    &__button {
      margin-top: 15px;
    }

    &__btn {
      width: 100%;
      min-width: auto;
      max-width: 250px;
      margin: 0 auto;
    }
  }
}

@media (max-width: 480px) {
  .image-text-block {
    margin: 10px 5px;
    width: calc(100% - 5px);

    &__container {
      border-radius: 15px;
    }

    &__image-wrapper {
      height: 200px;
      border-radius: 15px 15px 0 0 !important;
    }

    &__image img {
      border-radius: 15px 15px 0 0 !important;
    }

    &__content-wrapper {
      border-radius: 0 0 15px 15px !important;
    }

    &__content {
      padding: 20px 15px;
    }

    &__title {
      font-size: 24px;
    }

    &__subtitle,
    &__section-title {
      font-size: 18px;
    }

    &__text {
      font-size: 15px;
    }

    &__btn {
      font-size: 16px;
      padding: 10px 20px;
      width: 100%;
      max-width: 100%;
    }
  }
}

.text-circe-20 {
  font-family: 'Circe', sans-serif;
  font-size: 20px;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
}

.text-circe-bold-22 {
  font-family: 'Circe', sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
}

.color-green {
  color: #363;
}

.text-TTDrugs-Bold-40 {
  font-family: 'TTDrugs', sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;

  @media (max-width: 1200px) {
    font-size: 38px;
  }

  @media (max-width: 1024px) {
    font-size: 34px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 30px;
  }
}
</style>